import BillingsTaxiTaxiEditRequest, {
  BillingsTaxiTaxiEditRequestContribution,
  BillingsTaxiTaxiEditRequestContributionType,
  BillingsTaxiTaxiEditRequestNode,
} from "../../../../api/raily/billings/taxi-taxi/edit/billings-taxi-taxi-edit.request";
import BillingsTaxiTaxiEditParams, {
  BillingsTaxiTaxiEditParamsContributionType,
  BillingsTaxiTaxiEditParamsContribution,
  BillingsTaxiTaxiEditParamsNode,
} from "./billings-taxi-taxi-edit-params";

const createContributionType = (
  type:
    | BillingsTaxiTaxiEditParamsContributionType.BONUS_OTHER
    | BillingsTaxiTaxiEditParamsContributionType.PENALTY_WRONG_ROUTE
    | BillingsTaxiTaxiEditParamsContributionType.PENALTY_BEING_LATE
    | BillingsTaxiTaxiEditParamsContributionType.PENALTY_INCOMPATIBLE_CAR
    | BillingsTaxiTaxiEditParamsContributionType.PENALTY_OTHER,
):
  | BillingsTaxiTaxiEditRequestContributionType.BONUS_OTHER
  | BillingsTaxiTaxiEditRequestContributionType.PENALTY_WRONG_ROUTE
  | BillingsTaxiTaxiEditRequestContributionType.PENALTY_BEING_LATE
  | BillingsTaxiTaxiEditRequestContributionType.PENALTY_INCOMPATIBLE_CAR
  | BillingsTaxiTaxiEditRequestContributionType.PENALTY_OTHER => {
  switch (type) {
    case BillingsTaxiTaxiEditParamsContributionType.BONUS_OTHER:
      return BillingsTaxiTaxiEditRequestContributionType.BONUS_OTHER;
    case BillingsTaxiTaxiEditParamsContributionType.PENALTY_BEING_LATE:
      return BillingsTaxiTaxiEditRequestContributionType.PENALTY_BEING_LATE;
    case BillingsTaxiTaxiEditParamsContributionType.PENALTY_INCOMPATIBLE_CAR:
      return BillingsTaxiTaxiEditRequestContributionType.PENALTY_INCOMPATIBLE_CAR;
    case BillingsTaxiTaxiEditParamsContributionType.PENALTY_OTHER:
      return BillingsTaxiTaxiEditRequestContributionType.PENALTY_OTHER;
    case BillingsTaxiTaxiEditParamsContributionType.PENALTY_WRONG_ROUTE:
      return BillingsTaxiTaxiEditRequestContributionType.PENALTY_WRONG_ROUTE;
  }
};

const createContribution = (
  contribution: BillingsTaxiTaxiEditParamsContribution,
): BillingsTaxiTaxiEditRequestContribution => {
  switch (contribution.type) {
    case BillingsTaxiTaxiEditParamsContributionType.BONUS_FAVORABLE_DISTANCE:
      return {
        type: BillingsTaxiTaxiEditRequestContributionType.BONUS_FAVORABLE_DISTANCE,
        comment: contribution.comment,
        distance: contribution.distance,
        rate: contribution.rate,
      };
    case BillingsTaxiTaxiEditParamsContributionType.BONUS_OTHER:
    case BillingsTaxiTaxiEditParamsContributionType.PENALTY_BEING_LATE:
    case BillingsTaxiTaxiEditParamsContributionType.PENALTY_INCOMPATIBLE_CAR:
    case BillingsTaxiTaxiEditParamsContributionType.PENALTY_OTHER:
    case BillingsTaxiTaxiEditParamsContributionType.PENALTY_WRONG_ROUTE:
      return {
        type: createContributionType(contribution.type),
        comment: contribution.comment,
        amount: contribution.amount,
      };
  }
};

const createContributions = (
  contributions: BillingsTaxiTaxiEditParamsContribution[],
): BillingsTaxiTaxiEditRequestContribution[] => {
  return contributions.map(createContribution);
};

const createNode = (
  node: BillingsTaxiTaxiEditParamsNode,
): BillingsTaxiTaxiEditRequestNode => {
  return {
    allowCharge: node.allowCharge,
    checkoutDate: node.checkoutDate,
    checkoutEventId: node.checkoutEventUuid,
    description: node.description,
    distance: node.distance,
    editableCoordinates: node.editableCoordinates,
    haltingTime: node.haltingTime,
    highwayCharge: node.highwayCharge,
    id: node.uuid,
    lat: node.lat,
    lon: node.lon,
    nodeId: node.nodeUuid,
    orderId: node.orderUuid,
    plannedDate: node.plannedDate,
    plannedDistance: node.plannedDistance,
  };
};

const createNodes = (
  nodes: BillingsTaxiTaxiEditParamsNode[],
): BillingsTaxiTaxiEditRequestNode[] => {
  return nodes.map(createNode);
};

const createRequest = (
  params: BillingsTaxiTaxiEditParams,
): BillingsTaxiTaxiEditRequest => {
  return {
    billingContributions: createContributions(params.billingContributions),
    billingNodes: createNodes(params.billingNodes),
    billingUuid: params.billingUuid,
  };
};

const billingsTaxiTaxiEditParamsFactory = {
  createRequest,
};

export default billingsTaxiTaxiEditParamsFactory;
